var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import { useQuery } from "@tanstack/react-query";
import { rewardsCertificateCacheKey } from "../cacheKeys.js";
import queryFnFactory from "./query.js";
function useRewardsCertificateQuery({
  config,
  keyProps,
  queryOptions = {}
}) {
  return useQuery(__spreadValues({
    queryKey: rewardsCertificateCacheKey(keyProps),
    queryFn: queryFnFactory(config, keyProps)
  }, queryOptions));
}
export {
  useRewardsCertificateQuery
};
//# sourceMappingURL=rewardsCertificateQuery.js.map
